import { apiUrl } from "../../../setting";

export const addCustomerUrl = () => {
    return `${apiUrl}/createCustomer`;
};
export const addPosCustomerUrl = () => {
    return `${apiUrl}/createPosCustomer`;
};
export const getcustomerUrl = () => {
    return `${apiUrl}/customerList`;
};
export const getPosCustomerUrl = () => {
    return `${apiUrl}/customerListPos`;
};
export const singleCustomerUrl = (id) => {
    return apiUrl + "/getSingleCustomer/" + id;
};
export const updateCustomerUrl = () => {
    return `${apiUrl}/updateCustomer`;
  };
  export const deleteCustomerUrl = (id) => {
    return apiUrl + "/deleteCustomer/" + id;
  };
export const verifyGstinUrl = () => {
    return `${apiUrl}/verifyGstin`;
};
